// extracted by mini-css-extract-plugin
export default {"container":"PlayButton_container__hWXER","triangle":"PlayButton_triangle__2zHUe","square":"PlayButton_square__5ljAm"};